import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=09c90b09&scoped=true&"
import script from "./popover.vue?vue&type=script&lang=ts&"
export * from "./popover.vue?vue&type=script&lang=ts&"
import style0 from "./popover.vue?vue&type=style&index=0&id=09c90b09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c90b09",
  null
  
)

export default component.exports